// extracted by mini-css-extract-plugin
export default {"loading":"PF1ZxdkbHshihqwHTXB3-style-loading","recipeContainer":"AV_MFMbKv8IvWJKJBaZ_-style-recipeContainer"};